import React from "react";
import { m } from "motion/react";
import useUserStore, { useIndexStore } from "@/state/user/useUserStore";
import { TabText } from "@/components/styles";
import { Type } from "lucide-react";
import { ScrollView } from "react95";
import { TextInputComponent } from "@/components/ui/text-input-component";
import Image from "@/components/ui/image";
import styled from "styled-components";

const StyledMotionDiv = styled(m.div)`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;
  padding: 24px;
  box-sizing: border-box;

  @media (min-width: 1280px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

const TextComponent = ({
  parentVariants,
  childVariants,
  color,
}: {
  parentVariants: any;
  childVariants: any;
  color: string;
}) => {
  const [
    tabs,
    setTabs,
    setAssets,
    textFields,
    addTextField,
    restrictedFonts,
    uploadAssets,
    ratio,
    selectedAssets,
  ] = useUserStore((state) => [
    state.tabs,
    state.setTabs,
    state.setAssets,
    state.textFields,
    state.addTextField,
    state.restrictedFonts,
    state.uploadAssets,
    state.ratio,
    state.assets,
  ]);

  const [
    lastAssetIndex,
    setLastAssetIndex,
    lastTextFieldIndex,
    setLastTextFieldIndex,
  ] = useIndexStore((state) => [
    state.lastAssetIndex,
    state.setLastAssetIndex,
    state.lastTextFieldIndex,
    state.setLastTextFieldIndex,
  ]);

  const allFieldsLength =
    textFields.length + selectedAssets.length + uploadAssets.length;

  const setAssetsHandler = (img: string) => {
    const id = crypto.randomUUID();
    setAssets((currentAssets) => [
      ...currentAssets,
      {
        id: id,
        img: img,
        flipHorizontal: false,
        flipVertical: false,
        zIndex: allFieldsLength + 1,
        index: lastAssetIndex + 1,
      },
    ]);
    setLastAssetIndex(lastAssetIndex + 1);
  };

  return (
    <>
      <m.div
        variants={parentVariants}
        initial="initial"
        animate="animate"
        style={{
          background: "#cccccc",
          boxSizing: "border-box",
          borderRadius: "0.25rem",
          border: "4px solid #000000",
          boxShadow: "2px 2px 0px 0px #000000",
          maxHeight: "calc(100% - 60px)",
        }}
      >
        <m.div
          style={{
            background: color,
            boxSizing: "border-box",
            padding: "8px 8px 8px 8px",
            borderBottom: "4px solid #000000",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              padding: "0 8px",
            }}
          >
            <p
              style={{
                margin: 0,
                fontFamily: "var(--font-cabin-condensed)",
                fontSize: "20px",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                color: "#000",
              }}
            >
              Text
            </p>
          </div>
        </m.div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: `calc(100% - 68px)`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
            boxSizing: "border-box",
          }}
        >
          <ScrollView
            style={{
              height: "100%",
              maxHeight: "calc(100% - 80px)",
              margin: "0",
              padding: "0",
              width: "100%",
            }}
          >
            <m.div
              variants={childVariants}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: "24px",
                paddingBottom: "180px", // Extra padding for dropdown space
                boxSizing: "border-box",
              }}
            >
              {textFields.map((textField, index) => (
                <TextInputComponent
                  key={textField.id}
                  textField={textField}
                  color={color}
                  index={index + 1}
                />
              ))}
            </m.div>
          </ScrollView>
          <div
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "1rem",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <m.div
              style={{
                width: "100%",
                height: "3rem",
                background: color,
                display: "flex",
                boxSizing: "border-box",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                borderRadius: "0.25rem",
                color: "black",
                fontFamily: "var(--font-cabin-condensed)",
                fontSize: "1rem",
                border: "4px solid #000000",
                boxShadow: "2px 2px 0px 0px #000000",
              }}
              whileHover={{
                scale: 1.01,
                transition: {
                  duration: 0.15,
                  ease: "linear",
                },
              }}
              whileTap={{ scale: 0.99 }}
              onClick={() => {
                const id = crypto.randomUUID();
                addTextField({
                  id: id,
                  text: "",
                  font:
                    restrictedFonts && restrictedFonts.length > 0
                      ? restrictedFonts[0].value
                      : "title1",
                  fontSize: 44,
                  zIndex: allFieldsLength + 1,
                  index: lastTextFieldIndex + 1,
                });
                setLastTextFieldIndex(lastTextFieldIndex + 1);
              }}
            >
              Add Text
            </m.div>
          </div>
        </div>
      </m.div>
    </>
  );
};

export default TextComponent;
